/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Text, VFlow } from 'bold-ui'

interface SdcSecaoAlertaProps {
  titulo?: string
  conteudo?: string
  children?: React.ReactNode
}

export const SdcSecaoAlerta = (props: SdcSecaoAlertaProps) => {
  const { titulo, conteudo, children } = props

  if (!conteudo) return null

  const styles = createStyles()

  return (
    <VFlow vSpacing={0.25}>
      {titulo && <Text variant='h5'>{titulo}</Text>}
      {conteudo && (
        <div css={styles.conteudoTextHtml}>
          <Text component='div' dangerouslySetInnerHTML={{ __html: conteudo }} />
        </div>
      )}
      {children}
    </VFlow>
  )
}
const createStyles = () => ({
  conteudoTextHtml: css`
    padding: 0.5rem 1rem;

    p:not(:first-of-type) {
      margin-top: 0.5rem;
    }

    p + ul {
      margin-top: 0.25rem;
    }

    ul {
      margin: 0;
      list-style: none;
      padding-left: 0.5rem;
    }

    li {
      display: block;
    }

    li::before {
      content: '•';
      display: inline-flex;
      width: 1ch;
      margin-right: 0.5rem;
    }

    ul > li:not(:first-of-type):not(ul ul > li) {
      margin-top: 0.5rem;
    }

    ul ul > li {
      margin-top: 0.125rem;
    }

    ul ul {
      padding-left: 1rem;
    }

    ul > li > .atencaoBox {
      margin-left: calc(1ch + 0.313rem);
      margin-top: 0.25rem;
    }
  `,
})
